import { Box, styled } from '@mui/material';

export const ProviderInfoCardStyled = styled('div')({
  marginTop: '12px',
  border: '1px solid #BBC1D0',
  borderRadius: '4px',
  borderBottom: 'none',
});

export const ProviderFamilyInfoCardStyled = styled(Box)(({ theme }) => ({
  borderBottom: '1px solid #BBC1D0',
  padding: '24px 16px',
  [theme.breakpoints.up('md')]: {
    padding: '20px 25px 10px 25px',
  },
}));

export const ProviderInfoBoxStyled = styled(Box)({
  maxWidth: '400px',
});
